import { useEffect } from 'react';

// Loads a script tag once per URL for the lifetime of the app.
//
// We intentionally do not remove the script on cleanup. The Adobe PDF Embed
// SDK (the only consumer) uses deferred initialization: it walks
// `document.scripts` at instantiation time to locate itself and read its own
// `.src` for resolving sub-resources. If a React effect cleanup has removed
// the tag before that walk runs, Adobe's ScriptLoader throws
// "Cannot read properties of undefined (reading 'src')" and any page that
// mounts a PDFViewer hangs on Loading. Leaving the script in the DOM costs
// nothing — the browser dedupes by URL on subsequent appends.
const useScript = (url: string) => {
  useEffect(() => {
    const alreadyLoaded = Array.from(document.scripts).some((s) => s.src === url);
    if (alreadyLoaded) return;

    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    document.body.appendChild(script);
  }, [url]);
};

export default useScript;
